import { deliHistory } from '@global';
import { EntityType } from '@lib/deals';
import { format, lightFormat, parse } from 'date-fns';
import { isEqual } from 'lodash';
import qs from 'qs';
import policy from './policies.json';
import { DeliUser } from '@lib/common';
import { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import * as userService from 'services/user';
import { usePermissionsLoader } from 'services/permissions-dataloader.service';
/**
 * Convert the date object into Y-m-d formatted string.
 * @param date The date object to convert
 */
export function dateToYmdStr(date: Date) {
  return date && lightFormat(date, 'yyyy-MM-dd');
}

export function DateToYmdStr(date: Date | string) {
  if (!date) return null;

  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'yyyy-MM-dd');
}

/**
 * Convert the date string into a date object.
 * @param date The Y-m-d string to convert.
 */
export function YmdStrToDate(date: string) {
  return date && parse(date, 'yyyy-MM-dd', 0);
}

export function readableDate(date: Date | number) {
  return date && format(date, 'd LLL yyyy');
}
export function monthYearFormat(date: Date) {
  return date && date.toLocaleString('en-US', {
      month: 'short',
      year: 'numeric',
    });
}
export function dateToFormat(date: Date | number, format: string) {
  return date && lightFormat(date, format);
}

/**
 * Convert a string into capital case.
 * @param str The string to capitalize
 */
export function capitalCase(str: string) {
  if (!str) {
    return '';
  }
  return str[0].toUpperCase() + (str.slice(1) || '').toLowerCase();
}

/**
 * Converts confidence to percentage.
 * @param value Value to conver to percentage
 */
export function toPercentage(value: string | number) {
  return `${+(+value * 100).toFixed(2)}%`;
}

const typeToUrl = {
  [EntityType.company]: (id: string) => `${windowObj.RAZZLE_VTR_PINT_BACKEND}/companydetails/${id}`,
  [EntityType.content]: (id: string) => `${windowObj.RAZZLE_VTR_PINT_BACKEND}/contentdetails/${id}`,
  [EntityType.person]: (id: string) => `${windowObj.RAZZLE_VTR_PINT_BACKEND}/kg/person/${id}`,
};

/**
 * Get the Vitrina URL for the given entity.
 * @param id The id of the entity
 * @param type The type of the entity.
 */
export function vtrUrl(id: string, type: string) {
  return typeToUrl[type](id);
}

/**
 * Converts search filters into url query params and from query params to filters
 */
export const QueryParamsAdapter = {
  toParams: (state: object) => qs.stringify(state, { encodeValuesOnly: true, allowDots: true }),
  fromParams: (params: string) => qs.parse(params, { ignoreQueryPrefix: true, allowDots: true }),
} as const;

export function syncHistroyWithFilter<T extends object>(nextState: Partial<T>, defaultState: T) {
  // Filter out defaults from reflecting in url.
  const state = Object.fromEntries(
    Object.entries(nextState).filter(([k, v]) => !isEqual(defaultState[k], v))
  );

  const shouldClear = !Object.keys(state).length;

  deliHistory.replace({
    search: shouldClear ? '' : '?' + QueryParamsAdapter.toParams(state).toString(),
  });
}
// let user: DeliUser;

export function rbac(action: string, role: string, event: string) {
  // return false;
  const user = userService.getUser();
  const userRoles = user ? user.roleId.split(",") : ['super_admin'];
  const userRole = user ? user.roleId : 'super_admin';
  const userEvent = event ? event : 'Button';
  const deli_roles = ['Power_User',
    'Data_Managers',
    'Data_QC',
    'Deal_Curation',
    'Curation',
    'DEAL_Executor',
    'DEAL_Auditor', 'Data_Curation','Services_Curation', 'DELI_SUPER_ADMIN'];

  const intersection = userRoles.filter(element => deli_roles.includes(element));
  
  if(intersection?.length == 0){
    return false;
  }

  var buttons_permission = [];
  var pages_permission = [];
  intersection.map((role) => {
    const roleId = role.trim();
    if(policy.UI_Permissions[roleId] != null){
      buttons_permission = buttons_permission.concat(policy.UI_Permissions[roleId]['Button']);
      pages_permission = pages_permission.concat(policy.UI_Permissions[roleId]['pages']);
    }
  })

  const userPolicy = {"Button":buttons_permission, "pages": pages_permission}
  if (userRoles.includes('super_admin')){
    return false;
  }
  
  const userPolicy1 = userPolicy[event]
  if (userPolicy1.some(v => action.includes(v))) {
    if (action == '/company-content/search'){
      if (userPolicy1.includes(action)){
        return false;
      }
      else{
        return true;
      }
    }
    return false;
  }
  else{
    return true
  }
  // if (userPolicy.includes(action)) {
  //   return false;
  // } else {
  //   return true;
  // }
}

export const convertToDateTimeFromISOString = (isoDateString: string = "")=>{
  // Create a Date object from the ISO string
  const date = new Date(isoDateString);

  // Get date and time components
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Month is 0-indexed
  const day = date.getDate();
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // Determine AM/PM
  const ampm = hours >= 12 ? 'PM' : 'AM';   

  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Format the date and time as needed
  const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2,   
  '0')}:${seconds.toString().padStart(2, '0')} (${ampm})`;
  return formattedDate+" - "+formattedTime;
}

declare global {
  interface Window {
    _env_: any;
  }
}
export const windowObj = window._env_;
